import { hideLoader } from "action/loader/hideLoader";
import getCartLoyaltyApi from "api/shopping-cart/getCartLoyaltyApi";
import { getItemsApi } from "api/shopping-cart/getItemsApi";
import { getStore } from "store";
import isFeatureEnabled from "util/helper/isFeatureEnabled";
import { isCheckoutOrShoppingCartPage } from "util/url/checkRouteInclude";
import { showLoader } from "../loader/showLoader";
import { refeshShoppingCartState } from "./refeshShoppingCartState";
import { setCartLoyalty } from "./setCartLoyalty";

let isRefreshing = false;

export function refreshShoppingCart(callback = null, { loader = true } = {}) {
  const store = getStore();
  const { loggedIn, expConfigurations } = store.getState().authenticationState;
  const isLoyaltyEnabled = isFeatureEnabled(expConfigurations, "loyalty");
  const checkoutOrShoppingCartPage = isCheckoutOrShoppingCartPage(window.location.pathname);
  const callCartLoyaltyApi = loggedIn && isLoyaltyEnabled && checkoutOrShoppingCartPage;

  return (dispatch: any) => {
    if (isRefreshing) return Promise.resolve();
    isRefreshing = true;

    if (loader) {
      dispatch(showLoader());
    }
    const getShoppingCart = getItemsApi();
    const getCartLoyalty = callCartLoyaltyApi ? getCartLoyaltyApi() : Promise.resolve(null);

    if ((!loggedIn || !isLoyaltyEnabled) && checkoutOrShoppingCartPage) {
      dispatch(setCartLoyalty(null));
    }

    return Promise.allSettled([getShoppingCart, getCartLoyalty])
      .then(([shoppingCartRes, loyaltyRes]) => {
        if (shoppingCartRes.status === "fulfilled") {
          dispatch(refeshShoppingCartState(shoppingCartRes.value.data));
        }

        if (loyaltyRes.status === "fulfilled" && loyaltyRes.value) {
          dispatch(setCartLoyalty(loyaltyRes.value.data));
        }

        if (callback) {
          callback();
        }
      })
      .finally(() => {
        dispatch(hideLoader());
        isRefreshing = false;
      });
  };
}
